import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar';
import Header from '../components/dashboard/Header';

const DashboardLayout = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  
  // Sidebar collapsed state with localStorage persistence
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');

    return saved === 'true';
  });
  
  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Save collapsed state to localStorage
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', isSidebarCollapsed);
  }, [isSidebarCollapsed]);
  
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  
  // Calculate sidebar width
  const sidebarWidth = isDesktop ? (isSidebarCollapsed ? 64 : 224) : 0;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 pt-14">
      {/* Header spans full width */}
      <Header 
        onMobileMenuToggle={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
        isMobileSidebarOpen={isMobileSidebarOpen}
        onSidebarToggle={toggleSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      
      {/* Content area with sidebar and main content */}
      <div className="flex h-[calc(100vh-3.5rem)]">
        {/* Sidebar */}
        <Sidebar 
          isMobileOpen={isMobileSidebarOpen}
          onMobileClose={() => setIsMobileSidebarOpen(false)}
          isCollapsed={isSidebarCollapsed}
        />
        
        {/* Main content - Add left margin to account for fixed sidebar */}
        <div 
          className="flex-1 overflow-y-auto flex flex-col transition-all duration-300"
          style={{
            marginLeft: `${sidebarWidth}px`
          }}
        >
          {/* Page content */}
          <main className="py-4 flex-1">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <Outlet />
            </div>
          </main>
          
          {/* Footer - Always visible at bottom */}
          <footer className="bg-white border-t border-gray-200 py-3 mt-auto sticky bottom-0">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <p className="text-center text-xs text-gray-600">
                © 2025 Xloud Technologies Pvt Ltd. All rights reserved. | License Management System
              </p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;